import { APITransport } from '@client/transports/api';

export const DomainsService = {
  createDomain({ domainName, adminEmail, authCode, allowClone }) {
    return APITransport.post({
      path: '/rest/user/execute/createdomain',
      body: {
        domainname: domainName,
        adminemail: adminEmail,
        authcode: authCode,
        allowClone
      }
    });
  },
  clearDomainCache(params) {
    return APITransport.post({
      path: '/rest/user/execute/cleardomaincache',
      body: {
        ...params
      }
    });
  },
  cloneDomain({ authcode, cloneOptions, destdomains, sourcedomain }) {
    return APITransport.post({
      path: '/rest/user/execute/clonedomain',
      body: {
        authcode,
        cloneOptions,
        destdomains,
        sourcedomain
      }
    });
  },
  async getAll(params = {}) {
    const page = params?.page ? Math.max(0, params?.page - 1) : 0;

    const response = await APITransport.post({
      path: '/rest/user/search/domains',
      includeResponseMeta: true,
      body: {
        ...params,
        page
      }
    });

    if (!response) {
      return { data: [], headers: {} };
    }

    const list = Array.isArray(response?.data?.data)
      ? response.data.data
      : Array.isArray(response?.data)
        ? response.data
        : [];

    return {
      ...response,
      data: list,
      headers: response?.headers || {}
    };
  },
  getCSReport({ domainname, days = 60 }) {
    return APITransport.get({
      path: '/rest/user/report/csreport',
      query: {
        domainname,
        days
      }
    });
  },
  getDomainReport({ domainname, days = 60 }) {
    return APITransport.get({
      path: '/rest/user/report/domaininfo',
      query: {
        domainname,
        days
      }
    });
  },
  getInvoices(query) {
    return APITransport.get({
      path: '/rest/domain/report/invoices',
      query: {
        ...query,
        showPaid: true
      }
    });
  },
  getSPFReport({ domainname }) {
    return APITransport.get({
      path: '/rest/domain/report/spfinfo',
      query: {
        domainname
      }
    });
  },
  getUsage(query) {
    return APITransport.get({
      path: '/rest/domain/report/usage',
      query
    });
  },
  updateBillingId({ domainname, billingid, ybillingid, authcode }) {
    return APITransport.post({
      path: 'rest/user/execute/updatebilling',
      body: {
        domainname,
        billingid,
        ybillingid,
        authcode
      }
    });
  }
};
